moya.search = window.moya.search || {};

moya.search = $.extend({}, moya.search, {
	autocompleteSelect: function(event, ui) {
		if (ui.item && ui.item.value.url) {
			window.location = ui.item.value.url;
		}
		else if (ui.item.header) {
			$('#searchForm').submit();
		}
		return false;
	},

	autocompleteRender: function( ul, item ) {
		$(ul).addClass('headSearch');
		if (item.header) {
			return $( '<li class="header">' )
				.append('<span class="result__label">' +
					'<span class="result__title">' + item.label + '</span>' +
					'<span class="result__seeAll">' + item.value + '</span>' +
					'</span>')
				.appendTo( ul );
		}

		var label = item.label;
		if (item.value.types[0] == 'news') {
			label += '<span>(' + item.value.date + ')</span>';
		}

		return $( '<li class="result">' )
			.append('<span class="result__type"><i class="fa ' + moya.search.icons(item) + '"></i><span class="sr-only">' + item.value.type + '</span></span>')
			.append('<span class="result__label">' +
				'<span class="result__title">' + label + '</span>' +
			'</span>')
			.appendTo( ul );
	},

	icons: function(item) {
		var type = item.value.types[0],
			icons = [];
		icons['news'] = 'fas fa-newspaper';
		icons['meeting'] = 'fas fa-gavel';
		icons['employees'] = 'fas fa-user';
		icons['file'] = 'fas fa-file';
		icons['calendar'] = 'fas fa-calendar';
		icons['gallery'] = 'fas fa-camera-retro';

		if (type in icons) {
			return icons[type];
		}
		else {
			return 'fas fa-arrow-alt-circle-right';
		}
	}
});
